import { useSelector } from "react-redux"
import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import Btn from "../../components/shared/button/Btn"
import KiralikAracContainer from "../../components/ilanlarContainers/KiralikAracContainer"
import { useDispatch } from "react-redux"
import { showModal } from "../../features/modal/modalSlice"
import { useEffect, useState } from "react"
import { getRentalCar } from "../../features/ilanlar/ilanlarSlice"
import InputSelect from "../../components/shared/input/new/InputSelect"
import InputNewAracTypeSelect from "../../components/shared/input/new/InputNewAracTypeSelect"
import { AdminAracEkleOptions } from "../../utils/adminAracEkleOptions"
import InputSelectCity from "../../components/shared/input/new/InputSelectCity"
import useWindowDimensions from "../../hooks/useWindowSize"
import KiralikAracContainerMobile from "../../components/ilanlarContainers/KiralikAracContainerMobile"
import Pagination from "../../components/shared/Pagination"

const Container = styled.div`

width: 100%;

    .wrapper{
        display: flex;
        flex-direction: column;
        width: 100%;

        .content{
            gap: 60px;
            margin: 0 30px;
            margin-top: 20px;
            color: ${({ theme }) => theme.mainTextColor};
            .top-container{
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 30px;
                .inputs{
                  display: flex;
                  align-items: center;
                  gap: 10px;
                }
            }
            .titles {
              width: 100%;
              display: grid;
              grid-template-columns:  1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
              padding-inline: 10px;
              align-items: center;
              font-size: var(--font-size-sm);
              font-weight: var(--font-weight-lg);
                p{
                  text-align: center;
                }
            }
        }
    }

    @media (max-width: 1150px) {
      .top-container{
        flex-direction: column;
        align-items: flex-start !important;
        justify-content: flex-start !important;
        gap: 10px;
      }
    }

    @media (max-width: 500px) {
       
      .inputs{
        flex-direction: column;
      }
    }
`
const titles = ["İlan No","İlan Tarihi", "Araç Türü", "Kasa Tipi", "Çalışılmak İstenen İl", "Çalışılmak İstenen Güzergah", "Talep Edilen Yakıt Yüzdesi", "Talep Edilen Kira Bedeli", "İlan İçin Aranacak Telefon"]

const KiralikAraclar = () => {
  const {theme} = useSelector((state) => state.layout)
  const dispatch = useDispatch()
  const { rentalCarList } = useSelector((state) => state.ilanlar);
  const [arac, setArac] = useState("")
  const [advertUser, setAdvertUser] = useState({
    id:0,
    text:"Tümü"
  })
  const [il, setIl] = useState("")

  const {windowDimensions} = useWindowDimensions()

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  const totalPages = Math.ceil(rentalCarList / itemsPerPage);

  useEffect(() => {
    dispatch(getRentalCar({workCity: il?.value, vehicleType: arac?.name, isAdvertiserUser: advertUser?.id, page: currentPage}))
  }, [il, arac, advertUser, currentPage])

  return (
    <Container>
      <PageTopTitle title={"Kiralik Araçlar"} position='sticky'/>
      <div className="wrapper">
        <div className="content">
          <div className="top-container">
            <div className="inputs">
              <InputNewAracTypeSelect data={arac} setData={setArac} name={"arac"} labelText={"Araç Türü"} initialOptions={AdminAracEkleOptions} />
              <InputSelectCity data={il?.value} setData={setIl} name={"il"} labelText={"Çalışılacak İl"} />
              <InputSelect data={advertUser.text} setData={setAdvertUser} name={"advertUser"} labelText={"İlan Durumu"} initialOptions={[{text: "Tümü", id: 0}, {text: "İlanlarım", id: 1}, {text: "Diğer İlanlar", id: 2}]} />
            </div>
            
            <Btn handleClick={() => dispatch(showModal("addRentalCar"))} color="#E85446" bgColor="transparent" width={"120px"} padding="10px" >Araç İlanı Ekle</Btn>
          </div>

          {windowDimensions?.width > 1150 &&
            <div className="titles">
              {titles.map((item) => (
                <p>{item}</p>
              ))}
            </div>
          }
          
          {windowDimensions?.width > 1150 ? 
            rentalCarList?.map((item)=>(
              <KiralikAracContainer data={item} />
            ))
          :
            rentalCarList?.map((item)=>(
              <KiralikAracContainerMobile data={item} />
            ))
          }

          {(rentalCarList && rentalCarList?.length > 0) && (
            <Pagination
              totalPages={totalPages}
              handleClick={setCurrentPage}
              currentPage={currentPage}
            />
          )}
        </div>
      </div>
    </Container>
  )
}

export default KiralikAraclar